import { Component, ViewContainerRef, effect, inject, untracked, viewChild } from "@angular/core";
import { AbstractBlockComponent } from "../../abstract-block/abstract-block/abstract-block.component";
import { ContainerBlock } from "../../types/block";
import { BlockUtilService } from "../../services/block-util.service";

@Component({
  selector: "ail-container-block",
  template: "",
})
export class ContainerBlockComponent extends AbstractBlockComponent<ContainerBlock> {
  private _blockUtilService = inject(BlockUtilService);

  readonly containerBlock = viewChild("containerBlock", { read: ViewContainerRef });

  constructor() {
    super();
    effect(() => {
      const containerRef = this.containerBlock();
      const data = this.data();
      if (containerRef && data) {
        untracked(() =>
          this._blockUtilService.addBlocksToContainerRef(
            containerRef,
            this._blockUtilService.sortBlockList(data.blocks),
          ),
        );
      }
    });
  }
}
